interface CourseRowSkeletonProps {
    rows?: number;
}

/** 裸 <tr> 占位行,嵌入已有 <tbody> 使用(课程补水到位前) */
export function CourseRowSkeletonRows({ rows = 1 }: CourseRowSkeletonProps) {
    return (
        <>
            {Array.from({ length: rows }).map((_, i) => (
                <tr key={i} className="animate-pulse">
                    <td className="w-10 pl-4 pr-2 py-4">
                        <div className="w-5 h-5 bg-gray-100 rounded mx-auto" />
                    </td>
                    <td className="w-32 pl-2 pr-2 py-4">
                        <div className="h-4 bg-gray-100 rounded w-20" />
                    </td>
                    <td className="w-[32rem] pl-2 pr-4 py-4">
                        <div className="h-4 bg-gray-100 rounded w-3/4" />
                    </td>
                    <td className="px-2 py-4">
                        <div className="flex items-center justify-end gap-2">
                            <div className="w-6 h-6 bg-gray-100 rounded-full" />
                            <div className="w-7 h-7 bg-gray-100 rounded-full" />
                        </div>
                    </td>
                </tr>
            ))}
        </>
    );
}

/** 展开态详情区占位:折叠行用摘要直出,补水未到位时点击展开显示此骨架 */
export function CourseRowDetailSkeleton() {
    return (
        <tr>
            <td colSpan={4} className="px-4 pb-6 border-b">
                <div className="pl-8 py-2 space-y-3 animate-pulse">
                    <div className="h-3 bg-gray-100 rounded w-full" />
                    <div className="h-3 bg-gray-100 rounded w-5/6" />
                    <div className="h-3 bg-gray-100 rounded w-2/3" />
                    <div className="flex gap-2 pt-2">
                        <div className="h-9 bg-gray-100 rounded-lg w-36" />
                        <div className="h-9 bg-gray-100 rounded-lg w-32" />
                    </div>
                </div>
            </td>
        </tr>
    );
}

export default function CourseRowSkeleton({ rows = 3 }: CourseRowSkeletonProps) {
    return (
        <div className="border-t border-gray-50">
            <table className="w-full border-collapse">
                <tbody>
                    <CourseRowSkeletonRows rows={rows} />
                </tbody>
            </table>
        </div>
    );
}
